
import apiClient from "../utils/apiClient";


// reusable error handler
const handleApiError = (error, defaultMessage) => {
  console.error(defaultMessage, error);

  throw {
    status: error.response?.status,
    message:
      error.response?.data?.message ||
      error.response?.data?.detail ||
      defaultMessage,
    data: error.response?.data || null,
  };
};



// GET users
export const getUsersApi = async (params = {}, currentUser = null) => {
  try {
    const queryParams = { ...params };

    // apply organization filter automatically
    if (currentUser) {
      const role = currentUser.role || currentUser.group?.name || "";

      if (!["admin"].includes(role.toLowerCase())) {
        const orgId =
          currentUser.organization_id ||
          currentUser.organization ||
          null;

        if (orgId) {
          queryParams.organization = orgId;
        }
      }
    }

    const response = await apiClient.get("/auth/users/", {
      params: queryParams,
    });

    return {
      users: response.data?.data || [],
      pagination: response.data?.pagination || null,
    };

  } catch (error) {
    handleApiError(error, "Failed to fetch users.");
  }
};



// ADD user
export const addUserApi = async (formData) => {
  try {
    const response = await apiClient.post("/auth/users/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to create user.");
  }
};



// DELETE user
export const deleteUserApi = async (userId) => {
  try {
    await apiClient.delete(`/auth/users/${userId}/`);
    return true;

  } catch (error) {
    handleApiError(error, "Failed to delete user.");
  }
};



// UPDATE user
export const updateUserApi = async (id, formData) => {
  try {
    const response = await apiClient.patch(`/auth/users/${id}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to update user.");
  }
};


export const getUserProfileApi = async (id) => {
  const res = await apiClient.get(`/users/profile/${id}/`);
  return res.data;
};

export const updateUserProfileApi = async (id, data) => {
  const res = await apiClient.patch(`/users/profile/${id}/`, data);
  return res.data;
};